import { getLogger } from '@logtape/logtape';
import { AuthUser, getCurrentUser } from 'aws-amplify/auth';
import { useEffect } from 'react';

import { loadUserProperties } from '@/services/authService.ts';

import { useAuthStore } from '@/stores/authStore.ts';

const logger = getLogger(['hook', 'load-user']);

const useLoadUser = (): void => {
    useEffect(() => {
        const loadUser = async (): Promise<void> => {
            let user: AuthUser | undefined;
            try {
                user = await getCurrentUser();
            } catch (error) {
                logger.debug('Could not load the current user', { error: error });
            }

            await loadUserProperties();
            useAuthStore.setState({ user: user, is_user_set: true });
        };
        void loadUser();
    }, []);
};

export default useLoadUser;
